import { RESET_COPY } from '@eliadmin/core/src/components/dlz/auth/password-reset/password-reset-copy';
import { phoneHref } from '@eliadmin/core/src/utils/dlz/text';

/**
 * Figma „Nemáte prístup k e-mailu?“ (60155:20204): divider and the phone line under the first step.
 * Phone and opening hours come from the administration (props of the dialog); without a phone
 * there is nothing to call, so the block is left out.
 */
export function SupportHelp({ phone, hours }: { phone?: string; hours?: string }) {
  if (!phone) return null;

  return (
    <>
      <hr className="h-px w-full border-0 bg-[#E2E4E7]" />
      <p className="dlz-body-s text-center text-[#6B7079]">
        {RESET_COPY.help.question}
        <br />
        {RESET_COPY.help.call}{' '}
        <a
          href={phoneHref(phone)}
          className="rounded-sm text-[#D7191F] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012]"
        >
          {phone}
        </a>
        {hours ? ` (${hours})` : null}.
      </p>
    </>
  );
}
